// https://github.com/ljharb/proposal-global
var $export = require('./_export');

$export($export.S, 'System', {global: require('./_global')});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.system.global.js
// module id = 906
// module chunks = 40